import React, { FC } from 'react';

const ResponsiveTable: FC = ({ children }) => <div style={{ overflowX: 'auto' }}>{children}</div>;

export default ResponsiveTable;
